/** Group logo (uploaded) with emoji / dot fallback. Sizes: xs sm md lg */
const SIZES = { xs: 'w-4 h-4', sm: 'w-6 h-6', md: 'w-8 h-8', lg: 'w-12 h-12' };

export default function GroupLogo({ logoUrl, emoji, size = 'sm', fallback = null, className = '', testId }) {
  if (logoUrl) {
    return (
      <img
        src={`${process.env.REACT_APP_BACKEND_URL}${logoUrl}`}
        alt=""
        data-testid={testId || 'group-logo'}
        className={`${SIZES[size] || SIZES.sm} rounded-full object-cover shrink-0 border border-border ${className}`}
      />
    );
  }
  if (emoji) return <span className={`shrink-0 leading-none ${size === 'xs' ? 'text-sm' : 'text-base'}`} data-testid={testId ? `${testId}-emoji` : undefined}>{emoji}</span>;
  return fallback;
}
